import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal,Progress,Badge,Timeline,Alert } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,OrderedListOutlined,CalculatorFilled,SwapOutlined,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled,TrophyOutlined,CheckCircleOutlined,ExclamationCircleOutlined,ClockCircleOutlined,SafetyCertificateOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Tooltip,Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';

import * as serverconfig from '../../serverconn'

import { NavLink } from 'react-router-dom'
import * as primarycolor from '../../primarycolor'

import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import LocalHospitalSharpIcon from '@mui/icons-material/LocalHospitalSharp';

import Hub_DeliveriesList from './Hub_DeliveriesListView'
import Hub_OnlineAgentsList from './Hub_OnlineAgentsListView';

import Hub_AgentActivityMap from './Hub_AgentActivityMap'
import GraphsComponentHub from './GraphsComponentHub';


var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const { Title, Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;


const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;


var bizuserid= ''
var coodinated_hub= ''
var token= ''


class HubManagerDashBoard extends React.Component {

  state = {
    currentmonth:moment().format(monthdateFormat).toString(),
    companyprofile:{},
    datarequested:true,
    memberformvisible:false,
    transactformvisible:false,
    calculatorformvisible:false,
    members:[],
    loansformvisible:false,
    dashboardlocked:false,
    utilitiesmodalvisible:false,
    userprofile:{},
    userrights:{},
    nonworkingday:{},
    depositsno:0,
    withdrawsno:0,
    depositvolume:0,
    withdrawvolume:0,
    tranquerymode:'Daily',
    expensevolumes:0,
    incomevolumes:0,
    datareload:false,
    withdrawpercentage:0,
    withdrwdiff:0,
    depositpercentage:0,
    depositdiff:0,
    percenategincomes:0,
    incomediff:0,
    percenategexpnses:0,
    expensdiff:0,
    weeklydays:[],
    weeklydeposits:[],
    weeklywithdraws:[],
    weeklyincomes:[],
    weeklyexpenses:[],

    weeklychartdata:[],
    weeklychartitems:[],

    graphtranquerymode:'weekly',
    loanproccessuerymode:'daily',

    totalapplications:0,
    totalapplicationamounts:0,
    totalassessments:0,
    totalassessmentsamounts:0,
    totalapprovals:0,
    totalapprovalsamounts:0,
    totaldisbursements:0,
    totaldisbursementsamounts:0,

    projectedmonths:"three",
    monthsprojected:[],
    projectedinterest:[],
    projectedprinciple:[],

    applicationvsdates:[],
    applicationvs:[],
    issuancesvs:[],
    applicvsmode:'weekly',

    total_of_agents:0,

    healthcentres:[],
    delivery_agents:[],
    hub_deliveries:[],
    hub_performance:{},
    recent_activities:[]

  };

  callback =(key) =>{
    console.log(key);
    console.log(this.state.yearlymonthlysales)
  }

  // Generate hub performance metrics
  generateHubPerformance = () => {
    const totalDeliveries = 0; // Will be calculated from actual API data
    const completedDeliveries = 0; // Will be calculated from actual API data
    const onTimeDeliveries = 0; // Will be calculated from actual API data
    const avgResponseTime = 0; // Will be calculated from actual API data
    const hubEfficiency = 0; // Will be calculated from actual API data

    return {
      totalDeliveries,
      completedDeliveries,
      onTimeDeliveries,
      avgResponseTime,
      hubEfficiency,
      completionRate: totalDeliveries > 0 ? ((completedDeliveries / totalDeliveries) * 100).toFixed(1) : "0.0",
      onTimeRate: completedDeliveries > 0 ? ((onTimeDeliveries / completedDeliveries) * 100).toFixed(1) : "0.0"
    };
  }

  // Generate delivery performance chart data
  generateDeliveryPerformanceData = () => {
    // Chart data will be populated from actual API data when available
    return {
      labels: [],
      datasets: [
        {
          label: 'Scheduled',
          data: [],
          borderColor: 'rgba(255, 206, 86, 1)',
          backgroundColor: 'rgba(255, 206, 86, 0.2)',
          borderWidth: 2,
          fill: false,
        },
        {
          label: 'Completed',
          data: [],
          borderColor: 'rgba(75, 192, 192, 1)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          borderWidth: 2,
          fill: false,
        },
        {
          label: 'On Time',
          data: [],
          borderColor: 'rgba(54, 162, 235, 1)',
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderWidth: 2,
          fill: false,
        }
      ]
    };
  }

  // Generate hub efficiency radar chart
  generateHubEfficiencyData = () => {
    // Chart data will be populated from actual performance metrics when available
    return {
      labels: [],
      datasets: [{
        label: 'Current Performance',
        data: [],
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(54, 162, 235, 1)',
      }]
    };
  }

  // Generate health center status distribution
  generateHealthCenterStatusData = () => {
    // Calculate actual status distribution from health centers data
    const statusCount = {
      'Active': 0,
      'Pending': 0,
      'Issues': 0,
      'Maintenance': 0
    };

    this.state.healthcentres.forEach(center => {
      const status = center.status || 'Active'; // Default to Active if no status
      if (statusCount.hasOwnProperty(status)) {
        statusCount[status]++;
      } else {
        statusCount['Active']++; // Default unknown statuses to Active
      }
    });

    const statuses = Object.keys(statusCount);
    const counts = Object.values(statusCount);
    const colors = [
      'rgba(52, 211, 153, 0.8)',
      'rgba(251, 191, 36, 0.8)', 
      'rgba(248, 113, 113, 0.8)',
      'rgba(156, 163, 175, 0.8)'
    ];

    return {
      labels: counts.some(count => count > 0) ? statuses : ['No Data'],
      datasets: [{
        data: counts.some(count => count > 0) ? counts : [1],
        backgroundColor: counts.some(count => count > 0) ? colors : ['rgba(200, 200, 200, 0.8)'],
        borderColor: counts.some(count => count > 0) ? colors.map(color => color.replace('0.8', '1')) : ['rgba(200, 200, 200, 1)'],
        borderWidth: 2,
      }]
    };
  }

  componentDidMount(){

    if(localStorage.getItem("coodinated_hub")){
      coodinated_hub= localStorage.getItem("coodinated_hub")
    }else{
      coodinated_hub= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

   if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }
    
    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

   axios.get(serverconfig.backendserverurl+`/api/accounts/${bizuserid}`)
   .then(res => {
       this.setState({
        userprofile:res.data
       })

   })

   axios.get(serverconfig.backendserverurl+`/api/healthcentres/?collection_hub=${coodinated_hub}`)
   .then(res => {
       this.setState({healthcentres:res.data})
   })


  //  axios.get(serverconfig.backendserverurl+`/api/delivery_agents/?collection_hub=${coodinated_hub}`)
  //  .then(res => {
  //      this.setState({delivery_agents:res.data})
  //  })


    axios.get(`${serverconfig.backendserverurl}/customqueries/get_hubagents/${coodinated_hub}`)
      .then(res => {
        this.setState({
          delivery_agents: JSON.parse(res.data.report),
          datarequested: false
        });
      })
      .catch(error => {
        console.error('Error loading hub agents:', error);
        this.setState({ datarequested: false });
      });



   // Recent activities will be populated from actual API calls when available
   // recent_activities remains empty by default

   axios.get(serverconfig.backendserverurl+`/api/app_profile/${1}`)
   .then(res => {
       this.setState({
         companyprofile:res.data
       })

       this.setState({datarequested:false})
   })

}

render() {

if(this.state.dashboardlocked===true){
  return(
    <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
    <h3 style={{fontWeight:'bolder',color:'red'}}>NOTE: Your dashboard is currently locked. Contact system adminstrators.Your Licence may be expired or some thing else. Thanks</h3>
    </div>
  )
}else{

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
    }else{

      const hubPerformance = this.generateHubPerformance();
      const deliveryPerformanceData = this.generateDeliveryPerformanceData();
      const hubEfficiencyData = this.generateHubEfficiencyData();
      const healthCenterStatusData = this.generateHealthCenterStatusData();

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
          },
          tooltip: {
            mode: 'index',
            intersect: false,
          }
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: 'Time Period'
            }
          },
          y: {
            display: true,
            title: {
              display: true,
              text: 'Number of Deliveries'
            },
            beginAtZero: true
          }
        }
      };

      const radarOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
          }
        },
        scales: {
          r: {
            beginAtZero: true,
            pointLabels: {
              font: {
                size: 12
              }
            }
          }
        }
      };

      const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                const percentage = Math.round((context.parsed / total) * 100);
                return `${context.label}: ${context.parsed} (${percentage}%)`;
              }
            }
          }
        }
      };

        return(
          <div className="animated fadeIn">  
        <Tabs>

        <TabPane tab="📊 Hub Overview" key="01" >
          
          {/* Header Section */}
          <div style={{ marginBottom: '24px' }}>
            <Title level={2} style={{ color: primarycolor.primarycolor, marginBottom: '8px' }}>
              <SafetyCertificateOutlined /> Hub Management Dashboard
            </Title>
            <Text type="secondary">
              Comprehensive monitoring and control for your collection hub operations
            </Text>
          </div>

        


          {/* Statistics Cards */}
          <Row gutter={[24, 24]} style={{ marginTop: '32px', marginBottom: '24px' }}>
            <Col xs={24} sm={12} lg={6}>
              <NavLink to='/hub_deliveryagents/'> 
                <Card hoverable className="stat-card" style={{ 
                  textAlign: 'center', 
                  borderRadius: '12px', 
                  boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                  margin: '12px',
                  border: '1px solid #f0f0f0',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{ padding: '20px 12px' }}>
                    <SportsMotorsportsIcon style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                    <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                      {this.state.delivery_agents.length}
                    </Title>
                    <Text type="secondary" style={{ fontSize: '12px' }}>Hub Agents</Text>
                  </div>
                </Card>
              </NavLink>
            </Col>

            <Col xs={24} sm={12} lg={6}>
              <NavLink to='/hub_healthcenters/'> 
                <Card hoverable className="stat-card" style={{ 
                  textAlign: 'center', 
                  borderRadius: '12px', 
                  boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                  margin: '12px',
                  border: '1px solid #f0f0f0',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{ padding: '20px 12px' }}>
                    <LocalHospitalSharpIcon style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                    <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                      {this.state.healthcentres.length}
                    </Title>
                    <Text type="secondary" style={{ fontSize: '12px' }}>Spokes</Text> 
                  </div>
                </Card>
              </NavLink>
            </Col>

          </Row>

        </TabPane>

        <TabPane tab="🚚 Hub Deliveries" key="02" >
          <Hub_DeliveriesList />
        </TabPane>

        <TabPane tab={"🟢 Online Agents (" + this.state.delivery_agents.length + ")"} key="04" >
          <Hub_OnlineAgentsList />
        </TabPane>

        <TabPane tab={"🗺️ Agent Activity Tracking"} key="05">
          <Hub_AgentActivityMap />
        </TabPane>

        </Tabs>

        <Divider style={{ margin: '24px 0' }} />
        <GraphsComponentHub/>

        </div>
      )
    }
  
 }

}
}

export default HubManagerDashBoard; 
